import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/errors";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { resetPassword } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) { setErr("Passwords do not match"); return; }
    setBusy(true);
    try { await resetPassword(token, password); setDone(true); setTimeout(()=>navigate("/login"), 1500); }
    catch (e) { setErr(formatApiError(e)); }
    finally { setBusy(false); }
  };

  if (!token) return (
    <div className="max-w-md mx-auto px-6 py-24 text-center">
      <p className="text-red-700">Invalid or missing reset token.</p>
      <Link to="/forgot-password" className="text-[#8B7355] hover:text-[#3B2F2F] text-sm">Request a new link →</Link>
    </div>
  );

  return (
    <div className="relative min-h-[70vh]">
      <div className="blob blob-gold" style={{ width: 500, height: 500, top: 40, right: -180 }}/>
      <div className="max-w-md mx-auto px-6 py-16 relative">
        <div className="text-center mb-8">
          <div className="uppercase tracking-[0.3em] text-xs text-[#8B7355] mb-3">Reset password</div>
          <h1 className="font-serif-display text-5xl text-[#3B2F2F]">Set new password</h1>
        </div>

        {done ? (
          <div className="bg-white/80 rounded-3xl border border-stone-200 shadow-xl p-8 text-center" data-testid="reset-success">
            <div className="text-[#2E4A35] font-semibold mb-2">Password updated ✦</div>
            <p className="text-sm text-stone-500">Redirecting you to sign in…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white/80 rounded-3xl border border-stone-200 shadow-xl p-8 space-y-4" data-testid="reset-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-stone-500">New password (min 6 chars)</label>
              <input type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="reset-password"
                     className="mt-1 w-full bg-stone-50 border border-stone-200 rounded-full px-4 py-3 outline-none focus:border-[#3B2F2F]" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-stone-500">Confirm password</label>
              <input type="password" required minLength={6} value={confirm} onChange={(e)=>setConfirm(e.target.value)} data-testid="reset-confirm"
                     className="mt-1 w-full bg-stone-50 border border-stone-200 rounded-full px-4 py-3 outline-none focus:border-[#3B2F2F]" />
            </div>
            {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{err}</div>}
            <button type="submit" disabled={busy} data-testid="reset-submit"
                    className="w-full bg-[#3B2F2F] text-[#FDFBF7] rounded-full py-3 font-semibold hover:bg-black disabled:opacity-60">
              {busy ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
